/** External dependencies */
import { Offcanvas } from 'bootstrap';

/** Internal dependencies */
import { handleUserStats } from './handleUserStats';
import { setNoLeadscoringCookie } from './setNoLeadscoringCookie';

export function checkLeadscoring() {
    const leadscoring = document.querySelector('[data-ct-leadscoring-id]');

    if (!leadscoring) {
        return;
    }

    // get relevant info from markup
    const { ctLeadscoringId: id, ctLeadscoringPostType: postType, ctLeadscoringUrl: url } = leadscoring.dataset;

    // This also updates sessionStorage in the background
    const statsString = handleUserStats(id, postType);

    // check with backend if conditions for a form are met, display that form if applicable
    // request should return false if no condition is met or a form id
    // relevant form offcanvas is set to show
    fetch(`${url}/check-conditions/${statsString}/${id}`)
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Let's make sure WordPress returned JSON
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                throw new TypeError("Oops, we haven't got JSON!");
            }

            return response.json();
        })
        .then((result) => {
            // returns false if there is nothing to do - no form to show
            if (result) {
                // returns the form id and a wait time in an object
                // {formId: 2, wait: 0}

                // offcanvas id looks like `ct-leadscoring-form-${result.formId}`
                const offcanvasElement = document.getElementById(`ct-leadscoring-form-${result.formId}`);

                if (offcanvasElement) {
                    // init as bootstrap offcanvas
                    const bsOffcanvas = new Offcanvas(offcanvasElement);

                    // Timer ?
                    if (result.wait && result.wait > 0) {
                        setTimeout(() => {
                            bsOffcanvas.show();
                        }, parseInt(result.wait) * 1000); // wait time is specified in seconds
                    } else {
                        // Show offcanvas
                        bsOffcanvas.show();

                        // listen to the offcanvas hide event, if executed set a cookie that prevents leadscoring from popping up again.
                        offcanvasElement.addEventListener('hide.bs.offcanvas', setNoLeadscoringCookie);
                    }
                }
            }
        });
}
